import makeStyles from '@mui/styles/makeStyles';
import {
  BREAKPOINTS,
  FONT_16,
  FONT_20,
  FONT_26,
  FONT_30,
  FONT_40,
  FONT_50,
  FONT_64,
  PAGE_STYLES,
} from 'constants/styles';

const cardHeight = 530;

export default makeStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    page: {
      ...PAGE_STYLES,
      paddingTop: 230,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        paddingTop: 130,
      }
    },
    titleLabel: {
      whiteSpace: 'pre-line',
      textAlign: 'center',
      ...FONT_64,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        ...FONT_30,
      },
    },
    descriptionLabel: {
      whiteSpace: 'pre-line',
      marginTop: 20,
      textAlign: 'center',
      ...FONT_26,
      fontWeight: 400,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        marginTop: 12,
        ...FONT_16,
      },
    },

    logo: {
      display: 'none',

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        display: 'block',
        margin: '0 auto',
        marginBottom: 16,
      }
    },

    macbook: {
      width: '100%',
      objectFit: 'contain',
      objectPosition: 'top',
      marginTop: 80,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        marginTop: 24,
      }
    },

    subtitle: {
      ...FONT_50,
      textAlign: 'center',

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        ...FONT_26,
      },
    },

    valuesSubtitle: {
      marginTop: -62,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        marginTop: 74,
      },
    },

    valueList: {
      marginTop: 32,
      display: 'flex',
      gap: 20,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        flexDirection: 'column',
      },
    },

    valueItem: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#F7F7F9',
      padding: 32,
      alignItems: 'flex-start',
      borderRadius: 24,
    },

    valueItemTitle: {
      ...FONT_26,
      fontWeight: 400,
      marginTop: 20,
      marginBottom: 64,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        ...FONT_16,
      },
    },

    valueItemBade: {
      marginTop: 'auto',
      padding: '8px 18px 4px',
      borderRadius: 30,
      color: '#ffffff',
      backgroundColor: '#348AEB',
      whiteSpace: 'pre',
    },

    solutionSubtitle: {
      marginTop: 180,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        marginTop: 80,
      },
    },

    solutions: {
      marginTop: 32,
      display: 'flex',
      flexDirection: 'column',

      '& > * + *': {
        marginTop: 32,
      },
    },

    solution: {
      display: 'flex',
      backgroundColor: '#F7F7F9',
      borderRadius: 24,
      height: cardHeight,
      padding: '20px 100px',
      gap: 20,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        height: 'initial',
        padding: '24px 16px',
        flexDirection: 'column-reverse',
      },
    },

    solutionReverse: {
      flexDirection: 'row-reverse',

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        flexDirection: 'column-reverse',
      },
    },

    solutionImgContainer: {
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    solutionImg: {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
      boxShadow: ' 0px 32px 40px -16px rgba(15, 10, 71, 0.05)',

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        maxWidth: '50%',
        maxHeight: '50%',
        marginTop: 16,
      }
    },

    solutionText: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },

    solutionTitle: {
      ...FONT_40,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        ...FONT_16,
        fontWeight: 600,
        textAlign: 'center',
      },
    },

    solutionDescription: {
      ...FONT_20,
      fontWeight: 400,
      marginTop: 16,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        marginTop: 4,
        ...FONT_16,
        textAlign: 'center',
      },
    },

    mobileApp: {
      display: 'flex',
      flexDirection: 'row-reverse',
      borderRadius: 24,
      height: cardHeight,
      backgroundColor: '#3E5366',
      marginTop: 32,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        flexDirection: 'column-reverse',
        height: 'initial',
      },
    },

    mobileImgContainer: {
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
    },

    mobileImg: {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain',
      objectPosition: 'bottom',

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        marginTop: 16,
      }
    },

    mobileText: {
      padding: 62,
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        padding: '24px 16px',
      },
    },

    mobileTitle: {
      color: '#ffffff',
      ...FONT_40,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        textAlign: 'center',
        ...FONT_16,
        fontWeight: 600,
      },
    },

    mobileDescription: {
      color: '#ffffff',
      ...FONT_20,
      fontWeight: 400,
      marginTop: 20,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        textAlign: 'center',
        marginTop: 12,
        ...FONT_16,
      },
    },

    storeButtons: {
      display: 'flex',
      marginTop: 32,
      gap: 12,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        flexDirection: 'column',
        alignItems: 'center',
      },
    },

    storeButton: {
      border: 'none',
      outline: 'none',
    },
  },
  { name: 'RootPage' },
);
